export default __webpack_public_path__ + "static/door-closing-ef7687ac70fdf9dc6880136d3dc229cc.svg";